import {
  ButtonBase,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import React from 'react'

import noChannelLogo from '../../assets/images/noChannelLogo.svg'
import { persianRegex } from '../../helpers/regex'
import { LocalizedLink } from '../../routes/localizedRoutes'
import { Channel } from '../../types/channel'
import { useStyles } from './styles/ChannelDetailsContainer.styles'

interface Props {
  data: Channel
}
const ChannelDetailsContainer: React.FC<Props> = ({ data }) => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const { channelID, channelCode, name } = data.basicDetails

  const isPersian = persianRegex.test(name)

  return (
    <ButtonBase
      component={LocalizedLink}
      to={`/book/${channelID}/${channelCode}/${name}`}>
      <div className={classes.root}>
        <div className={classes.logoContainer}>
          <img
            className={classes.image}
            src={data.Logo?.url || noChannelLogo}
            alt="Logo"
          />
        </div>
        <div className={classes.nameContainer}>
          <Typography
            variant={isMobile ? 'h5' : 'h4'}
            style={isPersian ? { fontFamily: 'IranSans' } : undefined}>
            {name}
          </Typography>
        </div>
      </div>
    </ButtonBase>
  )
}
export default ChannelDetailsContainer
